import { useEffect, useState } from "react";
import "../DashboardTab4.css";
import {  MainSliderApi } from "../../../../../../../api/Api";
import { Link } from "react-router-dom";

export default function BottomSlider() {
    const [logData, setLogData] = useState([]);
    const [error, setError] = useState(null); // State to store error
    const [loading, setLoading] = useState(true); // State to store loading status

    const [credentials2] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        LOC_CODE: localStorage.getItem("LCODE") || "",

    });


    // const rowsPerPage = 15;

    const [credentials] = useState({
        USER_ID: localStorage.getItem("LoginID"),
        PLANT_code: localStorage.getItem("LCODE"),
        pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        Stype: "",
    });

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await MainSliderApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
                // setFilteredData(res.data); // Initialize filtered data
            } else {
                setLogData([]);
                // setFilteredData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData(); // Initial fetch

        // Set interval to refresh data every 10 minutes (600,000 ms)
        const intervalId = setInterval(() => {
            fetchLogData(); // Fetch data every 10 minutes
        }, 60000); // 

        // Cleanup function to clear interval on component unmount
        return () => clearInterval(intervalId);

    }, []);

     console.log("logdatabotttom", logData);

    // Get the list of offline inverters
    const offlineInverters = logData
        .filter(item => item?.STS === 'Offline')
        .map(item => item?.NAME);

        // console.log("offlineInverters", offlineInverters);

    return (
        <div className="w-100 my-4">
            <div className="row g-0">
                <div className="col-md-12 w-100 text-center bottomDash" style={{ borderTop: "1px solid lightgray" }}>

                    <p>
                        <span style={{ float: "left" }}>
                        
                        </span>

                        <span style={{ color: "darkgreen", fontSize: "16px" }}>Offline :</span>&nbsp;
                        {offlineInverters.length > 0 ? (
                            offlineInverters.map((name, index) => (
                                <span key={index} className="bottomBox blinkbottom mx-2">{name}</span>
                            ))
                        ) : (
                            <span className="bottomBox">No offline feeder</span>
                        )}


                    </p>

                </div>
            </div>
        </div>
    );
}
